import { GET_TALENTS, SET_RECRUITER } from "../constants/";

const recruiterDefaultState = {
  data: [],
  talents: null,
};

const recruiterReducer = (state = recruiterDefaultState, action) => {
  switch (action.type) {
    case SET_RECRUITER:
      return {
        ...state,
        data: action.payload,
      };
    case GET_TALENTS:
      return {
        ...state,
        talents: action.payload,
      };
    default:
      return state;
  }
};
export default recruiterReducer;
